import React from 'react'
import SectionType from 'models/types/ts/sectionType'
import AnimatedText from 'layouts/animated-text'
import style from './Hero.module.scss'

interface Props {
    section: SectionType
}

const Hero = ({ section }: Props): JSX.Element => {
    return (
        <div className={style.hero}>
            <div
                className={style.backgroundImage}
                style={{ backgroundImage: `url("${section.imageFile.url}")` }}
            />
            <div className={style.content}>
                <div className={style.headlines}>
                    <div className={style.headline}>
                        <AnimatedText>{section.headline}</AnimatedText>
                    </div>
                    <div className={style.teaser}>
                        <AnimatedText delay="0.3s">
                            {section.teaser}
                        </AnimatedText>
                    </div>
                    <div className={style.cta}>
                        <AnimatedText delay="0.6s">
                            {section.buttonText}
                        </AnimatedText>
                    </div>
                </div>
                <div className={style.description}>
                    <AnimatedText delay="0.9s">{section.body}</AnimatedText>
                </div>
            </div>
        </div>
    )
}

export default Hero
